import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";
import { WindowRefService } from '../../services/window-ref.service';
import {environment} from "../../../environments/environment";
import { SearchService } from '../../services/search/search.service';

type GuideBanner = {
  findCountryId?: number | string;
  articleUrl?: string;
  bannerPath?: string;
  name?: string;
  desktopEvent?: string;
  mobileEvent?: string;
};

@Component({
  selector: 'app-guide-banners',
  templateUrl: environment.mobile ? './guide-banners.component.mobile.html' : './guide-banners.component.html',
  standalone: true,
  imports: [CommonModule],
  styleUrls: environment.mobile ? ['./guide-banners.component.mobile.scss'] : ['./guide-banners.component.scss']
})
export class GuideBannersComponent implements OnInit, OnDestroy {

  guideBanners: Record<string, GuideBanner> = {};
  finalGuideBanners: GuideBanner[] = [];

  private readonly onSearchStartNew = () => this.getGuideBanners();

  constructor(
      @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
      private windowService: WindowRefService,
      private searchService: SearchService,
  ) {
    this.guideBanners = (this.hotelToursPageConfig.guideBanners || {}) as Record<string, GuideBanner>;
  }

  ngOnInit(): void {
    this.getGuideBanners();
    this.windowService.nativeWindow.addEventListener('search:start-new', this.onSearchStartNew);
  }

  ngOnDestroy(): void {
    this.windowService.nativeWindow.removeEventListener('search:start-new', this.onSearchStartNew);
  }

  private getGuideBanners(): void {
    if (!this.guideBanners || Object.keys(this.guideBanners).length === 0) {
      this.finalGuideBanners = [];
      return;
    }

    const countryId = this.resolveCountryId();
    const firstFlyShortBanner = this.guideBanners['firstFlyShortBanner'];
    const firstFlyFullBanner = this.guideBanners['firstFlyFullBanner'];
    const countryBanner = Object.values(this.guideBanners).find((banner) => {
      return banner?.findCountryId !== undefined
          && banner?.findCountryId !== null
          && this.resolveNumberValue(banner.findCountryId) === countryId;
    });

    const finalGuideBanners: GuideBanner[] = [];

    if (countryBanner && firstFlyShortBanner) {
      finalGuideBanners.push(firstFlyShortBanner, countryBanner);
    }

    if (finalGuideBanners.length === 0) {
      const fallbackBanner = environment.mobile ? firstFlyShortBanner : firstFlyFullBanner;

      if (fallbackBanner) {
        finalGuideBanners.push(fallbackBanner);
      }
    }

    this.finalGuideBanners = finalGuideBanners;
  }

  private resolveCountryId(): number {
    const lastSearchParams = this.searchService.getLastSearchParams() as any;
    const searchFormValues = this.hotelToursPageConfig.searchFormValues as any;
    const nativeWindow = this.windowService.nativeWindow as any;

    return this.resolveNumberValue(
      lastSearchParams?.countryId,
      lastSearchParams?.country,
      searchFormValues?.countryId,
      searchFormValues?.country,
      nativeWindow.lastSearchParams?.countryId,
      nativeWindow.lastSearchParams?.country,
      nativeWindow.mainForm?.country_id,
    );
  }

  private resolveNumberValue(...values: Array<number | string | null | undefined>): number {
    for (const value of values) {
      const numericValue = Number(value);

      if (Number.isFinite(numericValue) && numericValue > 0) {
        return numericValue;
      }
    }

    return 0;
  }

  bannerClicked(eventName?: string): void {
    if (!eventName) {
      return;
    }

    const brxTracking = (this.windowService.nativeWindow as any).brxTracking;

    if (brxTracking?.sendAnalyticsEvent) {
      brxTracking.sendAnalyticsEvent(eventName);
    }
  }

}
